import {
  CHAT_LIST_REQUEST,
  CHAT_LIST_SUCCESS,
  CHAT_LIST_FAIL,
  CHAT_LIST_UPDATE,
  CHAT_HISTORY_REQUEST,
  CHAT_HISTORY_SUCCESS,
  CHAT_HISTORY_FAIL,
  CHAT_OLDER_MESSAGES_REQUEST,
  CHAT_OLDER_MESSAGES_SUCCESS,
  CHAT_OLDER_MESSAGES_FAIL,
  MESSAGE_RECEIVED,
  MESSAGE_SEEN,
  SET_ACTIVE_CHAT,
  CHAT_UNREAD_UPDATE,
  USER_TYPING,
  USER_STOPPED_TYPING,
  MESSAGE_EDIT,
  MESSAGE_DELETE,
  CHAT_LAST_MESSAGE_UPDATE,
  CHAT_UPDATE,
  CHAT_LIST_ADD,

  CHAT_UPDATE_DATA_SUCCESS,
  CHAT_UPDATE_ROLE_SUCCESS,
  CHAT_TRANSFER_OWNERSHIP_SUCCESS,
  CHAT_ADD_MEMBER_SUCCESS,
  CHAT_REMOVE_MEMBER_SUCCESS,
  CHAT_LEAVE_SUCCESS,

  CHAT_CREATE_REQUEST,
  CHAT_CREATE_SUCCESS,
  CHAT_CREATE_FAIL,
  CHAT_CREATE_RESET,
  CHAT_MEMBERS_UPDATE, CHAT_REMOVE,
} from '../constants/chatConstants'


// -----------------------
const initialChatState = {
  chats: [],
  messagesByChat: {},
  historyByChat: {},
  membersByChat: {},
  activeChatId: null,
  unreadByChat: {},
  hasUnread: false,
  loadingChats: false,
  loadingHistory: false,
  error: null,
  typingByChat: {},
};

const mergeMessagesById = (current = [], incoming = []) => {
  const byId = new Map();

  [...current, ...incoming].forEach((message) => {
    byId.set(String(message.id), message);
  });

  return Array.from(byId.values()).sort(
    (a, b) => new Date(a.created_at) - new Date(b.created_at)
  );
};

export default function chatReducer(state = initialChatState, action) {
  switch (action.type) {

    // ===== CHAT LIST =====

    case CHAT_LIST_REQUEST: {
      return {
        ...state,
        loadingChats: true,
        error: null,
      };
    }

    case CHAT_LIST_SUCCESS: {
      // First-entry unread convergence: a stale /chat/ response must not
      // resurrect unread for the chat the user already opened (reset_unread
      // / mark_read may have raced ahead of this hydrate).
      const activeId =
        state.activeChatId == null ? null : String(state.activeChatId);
      const unreadByChat = Object.fromEntries(
        action.payload.map((c) => [
          c.id,
          activeId && String(c.id) === activeId ? 0 : c.unread_count,
        ]),
      );
      return {
        ...state,
        loadingChats: false,
        error: null,
        chats: action.payload,
        membersByChat: action.payload.reduce((acc, chat) => {
          acc[chat.id] = chat.members || [];
          return acc;
        }, {}),
        unreadByChat,
        hasUnread: Object.values(unreadByChat).some((count) => count > 0),
      };
    }

    case CHAT_LIST_FAIL: {
      return {
        ...state,
        loadingChats: false,
        error: action.payload,
      };
    }

    case CHAT_LIST_UPDATE: {
      const chatId = String(action.payload.chat_id);
      const senderId = action.payload.sender?.id;
      const myUserId = action.meta?.myUserId;
      const isSystemMessage = action.payload.type === "system";

      if (action.payload.reset_unread) {
        const unreadByChat = {
          ...state.unreadByChat,
          [chatId]: 0,
        };

        return {
          ...state,
          unreadByChat,
          hasUnread: Object.values(unreadByChat).some(count => count > 0),
        };
      }

      const updatedChats = state.chats.map(chat =>
        String(chat.id) === chatId
          ? {
            ...chat,
            last_message: action.payload,
            updated_at: action.payload.created_at,
          }
          : chat
      );

      const sortedChats = [...updatedChats].sort((a, b) => {
        const aDate = a.last_message?.created_at || a.updated_at;
        const bDate = b.last_message?.created_at || b.updated_at;
        return new Date(bDate) - new Date(aDate);
      });

      const isOwnMessage =
        senderId && myUserId && String(senderId) === String(myUserId);

      if (isSystemMessage) {
        return {
          ...state,
          chats: sortedChats,
        };
      }

      if (chatId === String(state.activeChatId) || isOwnMessage) {
        const unreadByChat = {
          ...state.unreadByChat,
          [chatId]: 0,
        };

        return {
          ...state,
          chats: sortedChats,
          unreadByChat,
          hasUnread: Object.values(unreadByChat).some(count => count > 0),
        };
      }

      const unreadByChat = {
        ...state.unreadByChat,
        [chatId]: (state.unreadByChat[chatId] || 0) + 1,
      };

      return {
        ...state,
        chats: sortedChats,
        unreadByChat,
        hasUnread: true,
      };
    }
    // case CHAT_LIST_UPDATE: {
    //   const chatId = String(action.payload.chat_id);

    //   // 1️⃣ оновлюємо last_message
    //   const updatedChats = state.chats.map(chat =>
    //     String(chat.id) === chatId
    //       ? { ...chat, last_message: action.payload }
    //       : chat
    //   );

    //   // 2️⃣ сортуємо за датою останнього повідомлення
    //   const sortedChats = [...updatedChats].sort((a, b) => {
    //     const aDate = a.last_message?.created_at || a.updated_at;
    //     const bDate = b.last_message?.created_at || b.updated_at;
    //     return new Date(bDate) - new Date(aDate);
    //   });

    //   // 3️⃣ якщо активний чат — НЕ чіпаємо unread
    //   if (chatId === state.activeChatId) {
    //     return {
    //       ...state,
    //       chats: sortedChats,
    //     };
    //   }

    //   // 4️⃣ якщо не активний — збільшуємо unread
    //   const unreadByChat = {
    //     ...state.unreadByChat,
    //     [chatId]: (state.unreadByChat[chatId] || 0) + 1,
    //   };

    //   return {
    //     ...state,
    //     chats: sortedChats,
    //     unreadByChat,
    //     hasUnread: true,
    //   };
    // }

    // ===== CHAT UNREAD =====

    case CHAT_UNREAD_UPDATE: {
      const { chat_id, unread_count } = action.payload;

      const finalUnread =
        chat_id === state.activeChatId ? 0 : unread_count;

      const updatedUnread = {
        ...state.unreadByChat,
        [chat_id]: finalUnread,
      };

      return {
        ...state,
        unreadByChat: updatedUnread,
        hasUnread: Object.values(updatedUnread).some(
          count => count > 0
        ),
      };
    }

    // ===== CHAT HISTORY =====

    case CHAT_HISTORY_REQUEST: {
      const chatId = action.payload?.chatId;

      return {
        ...state,
        loadingHistory: true,
        error: null,
        historyByChat: chatId
          ? {
            ...state.historyByChat,
            [chatId]: {
              ...(state.historyByChat[chatId] || {}),
              loadingInitial: true,
            },
          }
          : state.historyByChat,
      };
    }

    case CHAT_HISTORY_SUCCESS: {
      const chatId = String(action.payload.chatId);
      const currentMessages = state.messagesByChat[chatId] || [];

      return {
        ...state,
        loadingHistory: false,
        messagesByChat: {
          ...state.messagesByChat,
          [chatId]: mergeMessagesById(currentMessages, action.payload.messages),
        },
        historyByChat: {
          ...state.historyByChat,
          [chatId]: {
            ...(state.historyByChat[chatId] || {}),
            loadingInitial: false,
            loadingOlder: false,
            hasOlder: action.payload.hasOlder,
          },
        },
      };
    }

    case CHAT_HISTORY_FAIL: {
      return {
        ...state,
        loadingHistory: false,
        error: action.payload,
      };
    }

    case CHAT_OLDER_MESSAGES_REQUEST: {
      const chatId = String(action.payload.chatId);

      return {
        ...state,
        historyByChat: {
          ...state.historyByChat,
          [chatId]: {
            ...(state.historyByChat[chatId] || {}),
            loadingOlder: true,
          },
        },
      };
    }

    case CHAT_OLDER_MESSAGES_SUCCESS: {
      const chatId = String(action.payload.chatId);
      const currentMessages = state.messagesByChat[chatId] || [];

      return {
        ...state,
        messagesByChat: {
          ...state.messagesByChat,
          [chatId]: mergeMessagesById(currentMessages, action.payload.messages),
        },
        historyByChat: {
          ...state.historyByChat,
          [chatId]: {
            ...(state.historyByChat[chatId] || {}),
            loadingOlder: false,
            hasOlder: action.payload.hasOlder,
          },
        },
      };
    }

    case CHAT_OLDER_MESSAGES_FAIL: {
      const chatId = String(action.payload.chatId);

      return {
        ...state,
        historyByChat: {
          ...state.historyByChat,
          [chatId]: {
            ...(state.historyByChat[chatId] || {}),
            loadingOlder: false,
          },
        },
        error: action.payload.error,
      };
    }

    // ===== REALTIME MESSAGE =====
    case MESSAGE_RECEIVED: {
      const chatId = String(action.payload.chat_id);
      const exists = state.messagesByChat[chatId]?.some(
        m => String(m.id) === String(action.payload.id)
      );

      if (exists) return state;

      return {
        ...state,
        messagesByChat: {
          ...state.messagesByChat,
          [chatId]: [
            ...(state.messagesByChat[chatId] || []),
            action.payload,
          ],
        },
      };
    }

    // ===== REALTIME MESSAGE SEEN =====
    case MESSAGE_SEEN: {
      const { chat_id, user_id, message_ids } = action.payload;

      const messages = state.messagesByChat[chat_id];

      if (!Array.isArray(messages)) {
        return state;
      }

      return {
        ...state,
        messagesByChat: {
          ...state.messagesByChat,
          [chat_id]: messages.map(msg =>
            message_ids.map(String).includes(String(msg.id))
              ? {
                ...msg,
                seen_by: [
                  ...(msg.seen_by || []),
                  user_id,
                ],
              }
              : msg
          ),
        },
      };
    }

    // ===== ACTIVE CHAT =====

    case SET_ACTIVE_CHAT: {
      return {
        ...state,
        activeChatId: action.payload,
      };
    }

    case CHAT_LIST_ADD: {
      const exists = state.chats.some(
        c => String(c.id) === String(action.payload.id)
      );

      if (exists) return state;

      return {
        ...state,
        chats: [action.payload, ...state.chats],
        membersByChat: {
          ...state.membersByChat,
          [action.payload.id]: action.payload.members || [],
        },
        unreadByChat: {
          ...state.unreadByChat,
          [action.payload.id]: 0,
        },
      };
    }

    case USER_TYPING: {
      const { chatId, user } = action.payload;

      return {
        ...state,
        typingByChat: {
          ...state.typingByChat,
          [chatId]: {
            ...(state.typingByChat[chatId] || {}),
            [user.id]: user,
          },
        },
      };
    }

    case USER_STOPPED_TYPING: {
      const { chatId, userId } = action.payload;

      const chatTyping = { ...(state.typingByChat[chatId] || {}) };
      delete chatTyping[userId];

      return {
        ...state,
        typingByChat: {
          ...state.typingByChat,
          [chatId]: chatTyping,
        },
      };
    }

    // ===== MESSAGE EDIT =====
    case MESSAGE_EDIT: {
      const { chat_id, id } = action.payload;

      const messages = state.messagesByChat[chat_id];
      if (!Array.isArray(messages)) return state;

      return {
        ...state,
        messagesByChat: {
          ...state.messagesByChat,
          [chat_id]: messages.map(msg =>
            String(msg.id) === String(id)
              ? {
                ...msg,
                ...action.payload,
              }
              : msg
          ),
        },
      };
    }

    // ===== MESSAGE DELETE =====
    case MESSAGE_DELETE: {
      const { chat_id, id } = action.payload;

      const messages = state.messagesByChat[chat_id];
      if (!Array.isArray(messages)) return state;

      return {
        ...state,
        messagesByChat: {
          ...state.messagesByChat,
          [chat_id]: messages.map(msg =>
            String(msg.id) === String(id)
              ? {
                ...msg,
                is_deleted: true,
                text: "",
                image: null,
                file: null,
                image_name: "",
                file_name: "",
                shared_entity: null,
                is_entity_share: false,
              }
              : msg
          ),
        },
      };
    }

    case CHAT_LAST_MESSAGE_UPDATE: {
      const { chat_id, last_message } = action.payload;

      return {
        ...state,
        chats: state.chats.map(chat =>
          String(chat.id) === String(chat_id)
            ? {
              ...chat,
              last_message,
              updated_at: last_message?.created_at || chat.updated_at,
            }
            : chat
        ),
      };
    }

    case CHAT_UPDATE: {
      const chat = action.payload;

      return {
        ...state,
        chats: state.chats.map(c =>
          c.id === chat.id ? chat : c
        ),
        membersByChat: {
          ...state.membersByChat,
          [chat.id]: chat.members || [],
        },
      };
    }

    case CHAT_UPDATE_DATA_SUCCESS:
    case CHAT_UPDATE_ROLE_SUCCESS:
    case CHAT_TRANSFER_OWNERSHIP_SUCCESS:
    case CHAT_ADD_MEMBER_SUCCESS: {
      const chat = action.payload;
      if (!chat?.id) return state;
      return {
        ...state,
        chats: state.chats.map(c =>
          String(c.id) === String(chat.id) ? { ...c, ...chat } : c
        ),
        membersByChat: {
          ...state.membersByChat,
          [chat.id]: chat.members || state.membersByChat[chat.id] || [],
        },
      };
    }

    case CHAT_LEAVE_SUCCESS: {
      const chatId = String(action.payload?.chat_id);
      if (!chatId) return state;

      const messagesByChat = { ...state.messagesByChat };
      const historyByChat = { ...state.historyByChat };
      const membersByChat = { ...state.membersByChat };
      const unreadByChat = { ...state.unreadByChat };

      delete messagesByChat[chatId];
      delete historyByChat[chatId];
      delete membersByChat[chatId];
      delete unreadByChat[chatId];

      return {
        ...state,
        chats: state.chats.filter(c => String(c.id) !== chatId),
        messagesByChat,
        historyByChat,
        membersByChat,
        unreadByChat,
        hasUnread: Object.values(unreadByChat).some(count => count > 0),
      };
    }

    case CHAT_REMOVE_MEMBER_SUCCESS: {
      const chat = action.payload;
      if (!chat?.id) return state;
      return {
        ...state,
        chats: state.chats.map(c =>
          String(c.id) === String(chat.id) ? { ...c, ...chat } : c
        ),
        membersByChat: {
          ...state.membersByChat,
          [chat.id]: chat.members || [],
        },
      };
    }

    // CHAT MEMBERS UPDATE
    case CHAT_MEMBERS_UPDATE: {
      return {
        ...state,
        membersByChat: {
          ...state.membersByChat,
          [action.payload.chat_id]: action.payload.members || [],
        },
      };
    }

    // ===== CHAT CREATE =====
    case CHAT_CREATE_SUCCESS: {
      const chatId = String(action.payload.id);
      const withoutDup = state.chats.filter((c) => String(c.id) !== chatId);
      return {
        ...state,
        chats: [action.payload, ...withoutDup],
        membersByChat: {
          ...state.membersByChat,
          [action.payload.id]: action.payload.members || [],
        },
      };
    }

    // ===== CHAT REMOVE =====
    case CHAT_REMOVE: {
      const chatId = String(action.payload);

      const messagesByChat = { ...state.messagesByChat };
      const historyByChat = { ...state.historyByChat };
      const membersByChat = { ...state.membersByChat };
      const unreadByChat = { ...state.unreadByChat };

      delete messagesByChat[chatId];
      delete historyByChat[chatId];
      delete membersByChat[chatId];
      delete unreadByChat[chatId];

      return {
        ...state,
        chats: state.chats.filter(c => String(c.id) !== chatId),
        messagesByChat,
        historyByChat,
        membersByChat,
        unreadByChat,
      };
    }

    default:
      return state;
  }
}

// ===== CHAT CREATE =====

const initialChatCreateState = {
  loading: false,
  error: null,
  createdChat: null,
};

export const chatCreateReducers = (state = initialChatCreateState, action) => {
  switch (action.type) {
    case CHAT_CREATE_REQUEST:
      return { ...initialChatCreateState, loading: true };

    case CHAT_CREATE_SUCCESS:
      return { loading: false, error: null, createdChat: action.payload };

    case CHAT_CREATE_FAIL:
      return { loading: false, error: action.payload, createdChat: null };

    case CHAT_CREATE_RESET:
      return initialChatCreateState;

    default:
      return state;
  }
};
